'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroV2Container = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = require('react-redux');

var _CmsCta = require('components/CmsPage/modules/CmsCta');

var _FriendbuyWidget = require('components/Friendbuy/FriendbuyWidget');

var _PagePromotionCta = require('components/PagePromotion/PagePromotionCta');

var _promotions = require('constants/promotions');

var _video = require('constants/video');

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

var _Sagas = require('decorators/Sagas/Sagas');

var _decorator = require('helpers/decorator');

var _interpolate = require('helpers/interpolate');

var _verify = require('helpers/verify');

var _page = require('redux/modules/page');

var _user = require('redux/modules/user');

var _bound = require('redux/saga/entities/bound');

var _localStorage = require('redux/saga/helpers/local-storage');

var _cms = require('redux/saga/selectors/cms');

var _HeroV = require('./HeroV2');

var _herov = require('./herov2.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapCtas = function mapCtas(_ref, promoAlias) {
  var ctas = _ref.ctas,
      callToAction = _ref.callToAction,
      callToActionYouTube = _ref.callToActionYouTube;
  return ((0, _verify.isEmpty)(ctas) ? [callToAction || {}, callToActionYouTube || {}] : ctas).map(function (cta) {
    return cta.type === _CmsCta.CMS_CTA_TYPES.URL && !cta.url ? (cta.url = promoAlias ? '/pricing/' + promoAlias : '/pricing', cta) : cta;
  });
};

var mapPromoAlias = function mapPromoAlias(_ref2) {
  var promotionAlias = _ref2.promotionAlias;

  // Check to see if we are overriding the default promotion with
  // an Optimizely-provided one.
  if (promotionAlias === _promotions.GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS) {
    var sessionPromotionAlias = (0, _localStorage.readSessionStorage)(_PagePromotionCta.DEFAULT_PAGE_PROMOTION_SESSION_KEY, null, true);
    if (!(0, _verify.isBlank)(sessionPromotionAlias)) {
      return sessionPromotionAlias;
    }
  }

  return promotionAlias;
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var cmsPath = (0, _cms.selectCmsPath)(state);
  var referAFriend = _bound.friendbuy.data(state, _bound.friendbuy.lastLoadedKey(state)) || {};
  var isRaf = cmsPath.indexOf('/referral') === 0 || cmsPath === '/homepage' && !(0, _verify.isEmpty)(referAFriend);
  var isWelcomeHero = !!ownProps.isWelcomeHero && (0, _user.isLoggedIn)(state);
  var isLive = _video.CP_LIVE_URL_REGEX.test(cmsPath);
  var promoAlias = mapPromoAlias(ownProps);
  var ctas = mapCtas(ownProps, promoAlias);

  var interpolator = function interpolator(text) {
    return text;
  };
  if (isWelcomeHero) {
    interpolator = (0, _FriendbuyWidget.buildFriendbuyInterpolator)(state);
  } else if (isRaf) {
    var senderReward = referAFriend.sender_reward || referAFriend.currency_symbol + referAFriend.reward_amount;
    var receiverReward = referAFriend.receiver_reward || referAFriend.currency_symbol + referAFriend.reward_amount;
    interpolator = function interpolator(text) {
      return (0, _interpolate.interpolate)(text, {
        $RECEIVER_REWARD: receiverReward,
        $SENDER_FIRST_NAME: referAFriend.referrer_first_name,
        $SENDER_REWARD: senderReward
      });
    };
  }

  return {
    horizontalAlignment: ownProps.alignment,
    ctas: ctas,
    desktopImageUrl: ownProps.desktopImage,
    headerCtaCopy: ownProps.headerCtaCopy,
    heroTextColor: ownProps.heroTextColor || 'dark',
    hideHeaderCta: (0, _user.isLoggedIn)(state),
    interpolator: interpolator,
    isLeadCapture: !!ownProps.leadCapture,
    isLive: isLive,
    isRaf: isRaf,
    isWelcomeHero: isWelcomeHero,
    legal: ownProps.legal,
    mobileImageUrl: ownProps.mobileImage,
    promoAlias: promoAlias,
    subtitle: ownProps.subtitle || [],
    title: ownProps.title || [],
    titleSize: ownProps.titleSize || 'display'
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  ctaClick: _herov.ctaClick,
  setPagePromotion: _page.setPagePromotion,
  useSellHeader: _page.useSellHeader
};

var HeroV2Container = exports.HeroV2Container = (0, _decorator.decorateWith)(_TrackDwell2.default, (0, _Sagas.withSagas)({ watch: _herov.watchSaga, load: _herov.loadSaga }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_HeroV.HeroV2);